/**
 * The height of the broadcast notification.
 */
export const BROADCAST_NOTIFICATION_HEIGHT = 100;
